import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import productData from "../data/productData";
import { useParams } from "react-router-dom";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function ProductsDetails() {
    const { t } = useTranslation();
    const { id } = useParams();
    useScrollAnimation();
    const prod = productData.find(item => item.id === id);
    if (!prod) {
        return <div className="text-center text-red-500">{t("News not found")}</div>;
    }
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("Products Details")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] font-bold">
                        <Link to={"/"}>{t("Home")}</Link> -
                        <span className="text-[#017E89] capitalize">{t("Products Details")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 flex items-baseline gap-[7px]">
                        <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                        <div className="font-bold capitalize text-[25px] text-[#017e89]">{t(`${prod.category}`)} - {t(`${prod.subCategory}`)} </div>
                    </div>
                    <div className="f-col flex gap-[30px]">
                        <div className="w-100 js-scroll fade-btm w-[49%] h-[350px]">
                            <img className="w-[100%] h-[100%] object-cover rounded-[4px]" src={prod.image} alt={prod.name} />
                        </div>
                        <div className="w-100 w-[49%] flex flex-col gap-[25px]">
                            <div className="js-scroll fade-top font-bold capitalize text-[25px] text-[#017e89]">{t(`${prod.title}`)}</div>
                            <div>
                                <div className="js-scroll fade-top font-bold text-[22px] my-[3px]">{t("About Product")}</div>
                                <p className="js-scroll fade-top">
                                    {t(`${prod.description}`)}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}